export const BLOCK_PARAGRAPH = 'p';
export const BLOCK_QUOTE = 'blockquote';
export const BLOCK_ALIGN_LEFT = 'align-left';
export const BLOCK_ALIGN_CENTER = 'align-center';
export const BLOCK_ALIGN_RIGHT = 'align-right';
export const BLOCK_ALIGN_JUSTIFY = 'align-justify';
export const BLOCK_CODE = 'code-block';
export const BLOCK_UL = 'ul';
export const BLOCK_OL = 'ol';
export const BLOCK_LI = 'li';
export const BLOCK_INDENT = 'ident';
export const BLOCK_LINK = 'link';
export const BLOCK_FILE = 'file';
export const BLOCK_IMAGE = 'image';
export const BLOCK_HR = 'hr';
export const BLOCK_TABLE_WRAP = 'table-wrap';
export const BLOCK_TABLE = 'table';
export const BLOCK_TABLE_PRE = 'table-pre';
export const BLOCK_TABLE_SUF = 'table-suf';
export const BLOCK_TABLE_ROW = 'table-row';
export const BLOCK_TABLE_CELL = 'table-cell';
export const BLOCK_MENTION = 'mention';
export const BLOCK_TASK_LIST = 'task-list';